import React from 'react';
import FormGroupSelectInput from "../formGroupSelectInput";
import FormGroupTextInput from "../formGroupTextInput";
import Button from "../button";
import CenteredDots from "../General/centeredDots";
import FormResponseMessage from "../formResponseMessage";
import Dropzone from 'react-dropzone';
import { ACCEPTED_UPLOAD_FILES, CURRENCY, CURRENCY_CODE, CURRENCY_MENU_OPTIONS } from "../../helpers/variables";
import UpdateTabHOC from '../../containers/ApplicationTabs/updateTabHOC';
import CustomCheckbox from "../General/customCheckbox";
import moment from "moment/moment";
import FormGroupPlainText from "../formGroupPlainText";
import GeneralSVG from "../generalSVG";
import { FormGroup } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS } from '../../helpers/formGroupVariants';
import { amountOnChange } from '../../helpers/functions';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import useAmountField from '../../hooks/useAmountField';

const attachmentWordingMapping = {
    courtFees: "Please upload remission application form or calculator EX160C",
    medicalFees: "Please upload invoice",
    nonMedicalExpertsFees: "Please upload invoice",
    paginationCollation: "Please upload invoice",
    rehabilitation: "Please upload invoice",
};

const AdvancedDisbursementsForm = (props) => {
    const { mapADIdToExpenseType, fetchedAD, editingForm, formWasUpdated} = props;
    const formTitle = editingForm ? "Edit Advance Disbursement" : "New Advance Disbursement Request";

    const { error: amountError, validate: amountValidate, onBlur: amountOnBlur } = useAmountField({
        name: 'amount',
        value: props.formData.amount,
        onChange: props._handleNumberInputChange,
    });

    if(
        props.fetchingUpdateStatus
        || props.fetchingAdById
    ){
        return (
            <div className={"row"}>
                <h2 className="agents-list-title col-sm-12">
                    {formTitle}
                </h2>
                <div className="col-sm-12">
                    <CenteredDots/>
                </div>
            </div>
        )
    }

    if(
        props.shouldUpdate
        && props.editingForm === false
        && props.canApplyBasedOnApplicationPolicy
        && props.isSolicitorUser
        && !props.fetchingUpdateStatus
    ) {
        return (
            <div>
                <h2 className="agents-list-title col-sm-12">
                    {formTitle}
                </h2>
                <FormResponseMessage
                    Message={'You must provide a policy update before applying for advance disbursements.'}
                    LeftWrapper=""
                    CenterWrapper="col-sm-12"
                    MessageStyle="formResponseMessage-reject"
                />
                <UpdateTabHOC
                    shouldInputsTakeAllSpace={true}
                    SelectedAppId={props.applicationId}
                    UserRole={props.userRole}
                />
            </div>
        )
    }

    return (
        <div className="row">
            {
                props.isSolicitorUser?
                    <h2 className="agents-list-title col-sm-12">
                        {formTitle}
                    </h2>
                    :
                    null
            }
            {
                !props.canApplyBasedOnApplicationPolicy && props.isSolicitorUser?
                    <FormResponseMessage
                        Message={'You cannot apply for advance disbursements for this application policy.'}
                        LeftWrapper=""
                        CenterWrapper="col-sm-12 mb-15"
                        MessageStyle="formResponseMessage-reject"
                    />
                    :
                    null
            }
            <div className="col-sm-12">
                <form className="form-horizontal" onSubmit={props._handeSubmit}>
                    {
                        props.isSolicitorUser && props.canEdit?
                            <FormGroupSelectInput
                                Disabled={props.isSolicitorUser && props.formData.canceled}
                                Label="Disbursement Type"
                                LeftWrapper="col-sm-3"
                                Value={props.formData.disbursementsType}
                                Name="disbursementsType"
                                HandleInputChange={props._handleSelectInputChange}
                                Options={props.disbursementTypesOptions}
                                CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                                RightWrapper=""
                                Required={true}
                                SelectStyle={'form-control formGroupSelectInput-select'}
                            />
                            :
                            <FormGroupPlainText
                                Label="Disbursement Type"
                                InputWrapper="manageSolicitorAccount-data col-xs-9"
                                Text={props._getExpenseTypeName(props.formData.disbursementsType)}
                            />
                    }
                    {
                        props.isSolicitorUser && props.canEdit?
                            <FormGroup
                                variant={FORM_GROUP_VARIANTS.CURRENCY}
                                labelSize={"col-sm-3"}
                                inputSize={"col-sm-6 amount-input-wrapper"}
                                label={CONTENT_STRINGS.AMOUNT_OF_FEE}
                                errorMessage={amountError}
                                inputProps={{
                                    name: 'amount',
                                    value: props.formData.amount || '',
                                    disabled: props.isSolicitorUser && props.formData.canceled,
                                    onBlur: amountOnBlur,
                                    onChange: amountOnChange(props._handleNumberInputChange, amountValidate),
                                    disabledDropdown: true,
                                    handleOptionSelect: () => {},
                                    menuOptions: CURRENCY_MENU_OPTIONS,
                                    selectedCurrency: { sign: `${CURRENCY}`, code: `${CURRENCY_CODE}` },
                                    required: true,
                                    autoComplete: 'off',
                                }}
                            />
                            :
                            <FormGroupPlainText
                                Label="Amount of fee"
                                InputWrapper="manageSolicitorAccount-data col-xs-9"
                                Text={props.formData.amount}
                            />
                    }
                    {
                        props.isCourtFeesAd &&  props.isSolicitorUser && props.canEdit?
                            <FormGroupSelectInput
                                Disabled={props.isSolicitorUser && props.formData.canceled || (props.fetchingApplicationPolicy)}
                                Label="Damages"
                                LeftWrapper="col-sm-3"
                                Value={props.formData.damageRange}
                                Name="damageRange"
                                HandleInputChange={props._setDamageRange}
                                Options={props.damageOptions}
                                CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                                RightWrapper=""
                                Required={true}
                                SelectStyle={'form-control formGroupSelectInput-select'}
                            />
                            :
                            null
                    }
                    {
                        props.isSolicitorUser && props.canCancelAd?
                            <div className="form-group">
                                <div className="col-sm-3">
                                    <label className="control-label.text-left formGroup-textInput-label">
                                        Withdraw Advance Disbursement Request
                                    </label>
                                </div>
                                <div className="col-sm-6">
                                    <CustomCheckbox
                                        name={"canceled"}
                                        checked={props.formData.canceled}
                                        label=""
                                        _onChange={props._handleCheckboxChange}
                                    />
                                </div>
                            </div>
                            :
                            null
                    }
                    {
                        props.isAragUser?
                            <div>
                                <FormGroupSelectInput
                                    Disabled={(
                                        (
                                            fetchedAD.disbursementStatusMachineName === "approved"
                                            && fetchedAD.paymentInstructionId
                                        )
                                        || fetchedAD.disbursementStatusMachineName === "settled"
                                        || fetchedAD.disbursementStatusMachineName === "paid"
                                        || fetchedAD.disbursementStatusMachineName === "part-settled"
                                    )}
                                    Required={true}
                                    Label="Status"
                                    LeftWrapper="col-sm-3"
                                    Value={props.formData.status}
                                    Name="status"
                                    HandleInputChange={props._handleSelectInputChange}
                                    Options={props.advanceDisbursementsStatusOptions}
                                    CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                                    SelectStyle={'form-control formGroupSelectInput-select'}

                                />
                                {props.formData.status == 'rejected'  ?
                                    <div>
                                        <FormGroupSelectInput
                                            Required={true}
                                            Label="Reason"
                                            LeftWrapper="col-sm-3"
                                            Value={props.formData.rejectionReason}
                                            Name="rejectionReason"
                                            HandleInputChange={props._handleSelectInputChange}
                                            Options={props.advanceDisbursementsRejectionReasonsOptions}
                                            CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                                            SelectStyle={'form-control formGroupSelectInput-select'}
                                        />
                                    </div>:null
                                }
                                {
                                    props.formData.status == 'rejected' && props.formData.rejectionReason == 'Other' ?
                                    <div>
                                        <FormGroupTextInput
                                            Label="Details"
                                            InputWrapper="col-sm-6"
                                            Required={true}
                                            Name="rejectionReasonDetails"
                                            Type="text"
                                            Value={props.formData.rejectionReasonDetails}
                                            HandleInputChange={props._handleTextInputChange}/>   
                                    </div>
                                    :null
                                }
                                <FormGroupPlainText
                                    Label={'Date created'}
                                    InputWrapper="manageSolicitorAccount-data col-xs-9"
                                    Text={props.formData.creationDate?moment(props.formData.creationDate).format("DD/MM/YYYY"):''}
                                />
                                <FormGroupPlainText
                                    Label={'Date paid'}
                                    InputWrapper="manageSolicitorAccount-data col-xs-9"
                                    Text={props.formData.paymentDate?moment(props.formData.paymentDate).format("DD/MM/YYYY"):''}
                                />
                            </div>
                            :
                            null
                    }
                    { (props.formData.disbursementsType && props.isSolicitorUser && props.canEdit) && (
                            <div className="form-group">
                                <div className="col-sm-6 col-sm-offset-3">
                                    <Dropzone onDropAccepted={props._onDrop}
                                              accept={ACCEPTED_UPLOAD_FILES}
                                              className="newApplication-dropzone">
                                        <p>
                                            {
                                                mapADIdToExpenseType(props.formData.disbursementsType).machineName?
                                                    attachmentWordingMapping[
                                                        mapADIdToExpenseType(props.formData.disbursementsType).machineName
                                                        ]
                                                    : null
                                            }
                                        </p>
                                    </Dropzone>
                                </div>
                            </div>
                        )
                    }
                    {
                        props.isAragUser || props.canEdit || props.canCancelAd?
                            <div className="form-group">
                                <div className="col-sm-3"></div>
                                <div className="col-sm-6">
                                    <Button
                                        disabled={(
                                            (
                                                fetchedAD.disbursementStatusMachineName === "approved"
                                                && fetchedAD.paymentInstructionId
                                            )
                                            || fetchedAD.disbursementStatusMachineName === "settled"
                                            || fetchedAD.disbursementStatusMachineName === "paid"
                                            || !formWasUpdated()
                                        )}
                                        wrapper="btn-wrapper-forForms"
                                        btnType="submit"
                                        btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                        label={props.submitButtonLabel}
                                    />
                                    <Button
                                        clickHandler={props._cancel}
                                        wrapper="btn-wrapper-forForms"
                                        btnType="button"
                                        btnStyle={'btn btn-primary btn-xs sharp white'}
                                        label="Cancel"
                                    />
                                </div>
                            </div>
                            :
                            null
                    }
                    {
                        props.successResponseMsg?
                            <FormResponseMessage
                                Message={props.successResponseMsg}
                                LeftWrapper="col-sm-3"
                                CenterWrapper="col-sm-6"
                                MessageStyle="formResponseMessage-reject"
                            />
                            :
                            null
                    }
                    {
                        props.failedResponseMsg?
                            <FormResponseMessage
                                Message={props.failedResponseMsg}
                                LeftWrapper="col-sm-3"
                                CenterWrapper="col-sm-6"
                                MessageStyle="formResponseMessage-reject"
                            />
                            :
                            null
                    }
                    {
                        props.postingAdvancedDisbursement ||  props.patchingAdvanceDisbursement?
                            <div className="form-group">
                                <div className="col-sm-3"></div>
                                <div className="col-sm-6">
                                    <CenteredDots/>
                                </div>
                            </div>
                            :
                            null
                    }
                    {
                        props.fetchingApplicationPolicy?
                            <div className="form-group">
                                <div className="col-sm-3"></div>
                                <div className="col-sm-6">
                                    <CenteredDots text={'Updating application policy'}/>
                                </div>
                            </div>
                            :
                            null
                    }
                </form>
                {
                    props.isSolicitorUser && props.canEdit ?
                        <div className="row">
                            <div className="col-sm-3"></div>
                            <div className="col-sm-6">
                                <ul className="newApplication-attachment-list">
                                    {props.formData.attachments.length > 0 ?
                                        props.formData.attachments.map((attachments, index) => {
                                            return <li key={index}>
                                                <div className="row">
                                                    <div className="col-sm-12 attachment-remove__wrapper">
                                                        <div
                                                            className="attachment-remove"
                                                            onClick={() => props._removeAdFormAttachment(index)}>X
                                                        </div>
                                                        {'  '}
                                                        {attachments.name}
                                                    </div>
                                                </div>
                                            </li>
                                        })
                                        :
                                        null
                                    }
                                </ul>
                            </div>
                        </div>
                        :
                        null
                }
                {
                    props.isAragUser || (props.isSolicitorUser && !props.canEdit && !props.canCancelAd)?
                        <div>
                            {
                                props.formData.attachments.length !== 0?
                                    <div className="">
                                        <h4 >Files Attached</h4>
                                        <ul className="newApplication-attachment-list">
                                            {
                                                props.formData.attachments.map((attachments, index) => {
                                                    return <li key={index}>
                                                        <a onClick={() => props._getFileFromBase64(attachments)}
                                                           className="applicationPolicy-document-tab-link">
                                                            <GeneralSVG
                                                                SvgWrapper="generalTab-download-wrapper inlineBlock"
                                                                Label="Download"
                                                                Svg={<svg xmlns="http://www.w3.org/2000/svg"
                                                                          viewBox="0 0 10 10"><title>Asset
                                                                    9</title>
                                                                    <g id="Layer_2" data-name="Layer 2">
                                                                        <g id="info">
                                                                            <path
                                                                                d="M9.5,6a.5.5,0,0,0-.5.5V9H1V6.5a.5.5,0,0,0-1,0V10H10V6.5A.5.5,0,0,0,9.5,6Z"/>
                                                                            <path
                                                                                d="M5,7.21,7.35,4.85a.5.5,0,0,0-.71-.71L5.5,5.29V0h-1V5.29L3.35,4.15a.5.5,0,0,0-.71.71Z"/>
                                                                        </g>
                                                                    </g>
                                                                </svg>}
                                                            />
                                                        </a>
                                                        {' ' + attachments.name}
                                                    </li>
                                                })
                                            }
                                        </ul>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                        :
                        null
                }
            </div>
        </div>
    )
};

export default AdvancedDisbursementsForm;
